import { apiClient } from '@/shared/lib/apiClient';
import type {
  PlanResponseDTO,
  PlanListQuery,
  PlanListResponse,
  CreatePlanDTO,
  UpdatePlanDTO,
} from '../types';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function listPlans(query?: PlanListQuery): Promise<PlanListResponse> {
  const params: Record<string, string> = {};
  if (query?.cursor) params['cursor'] = query.cursor;
  if (query?.limit !== undefined) params['limit'] = String(query.limit);
  if (query?.product_id) params['product_id'] = query.product_id;
  if (query?.is_active !== undefined) params['is_active'] = String(query.is_active);

  const res = await apiClient.get<ApiResponse<PlanListResponse>>('/api/v1/plans', { params });
  return res.data;
}

export async function listProductPlans(
  productId: string,
  query?: Omit<PlanListQuery, 'product_id'>,
): Promise<PlanListResponse> {
  const params: Record<string, string> = {};
  if (query?.cursor) params['cursor'] = query.cursor;
  if (query?.limit !== undefined) params['limit'] = String(query.limit);
  if (query?.is_active !== undefined) params['is_active'] = String(query.is_active);

  const res = await apiClient.get<ApiResponse<PlanListResponse>>(
    `/api/v1/products/${productId}/plans`,
    { params },
  );
  return res.data;
}

export async function getPlan(id: string): Promise<PlanResponseDTO> {
  const res = await apiClient.get<ApiResponse<PlanResponseDTO>>(`/api/v1/plans/${id}`);
  return res.data;
}

export async function createPlan(data: CreatePlanDTO): Promise<PlanResponseDTO> {
  const res = await apiClient.post<ApiResponse<PlanResponseDTO>>('/api/v1/plans', data);
  return res.data;
}

export async function updatePlan(id: string, data: UpdatePlanDTO): Promise<PlanResponseDTO> {
  const res = await apiClient.patch<ApiResponse<PlanResponseDTO>>(`/api/v1/plans/${id}`, data);
  return res.data;
}

export async function deletePlan(id: string): Promise<void> {
  await apiClient.delete<ApiResponse<void>>(`/api/v1/plans/${id}`);
}
